import { AudioPlayContext } from '@/contexts/AudioPlayContext';
import { CdnContext } from '@/contexts/CdnContext';
import { GlobalDataContext } from '@/contexts/GlobalDataContext';
import i18n from '@/modules/locales/i18n';
import { getLandingState } from '@/modules/main/selector';
import { CancelButton } from '@/modules/popup/svg';
import { Bet } from '@/modules/report/slice/betRecord';
import { RootState } from '@/store/store';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import { Dispatch, SetStateAction, useContext, useEffect } from 'react';
import { useSelector } from 'react-redux';
type Props = {
    open: boolean;
    bet: Bet;
    setIsOpen: Dispatch<SetStateAction<boolean>>;
};

export const Playback = (props: Props) => {
    const { playbackUrl } = useContext(CdnContext);
    const { playButtonAudio } = useContext(AudioPlayContext);
    const { externalWindowRef } = useContext(GlobalDataContext);
    const { open, setIsOpen, bet } = props;
    let url = playbackUrl;
    const { webView } = useSelector((state: RootState) =>
        getLandingState(state)
    );
    const playbackLang = i18n.language.replace('-', '_');

    if (url && window.location.protocol == 'https:') {
        url = url.replace('http://', 'https://');
    }

    url = `${url}${bet.GameID}&lang=${playbackLang}&host_id=${bet.HostID}&d=2`

    const handleCancel = () => {
        setIsOpen(false);
        playButtonAudio();
    };
    useEffect(() => {
        if (!webView) {
            handleCancel();
        }
    }, [webView, setIsOpen]);

    if (webView) {
        return (
            <Dialog open={open} fullScreen disableEscapeKeyDown>
                    <iframe
                        style={{ width:'100%', height:'90%' }}
                        src={url}
                    />
                <Box sx={{ display:'flex', justifyContent:'center', margin:'1rem 0', width: '100%' }}>
                    <CancelButton width={'4rem'} height={'4rem'}
                        onClick={handleCancel}
                    />
                </Box>
            </Dialog>
        );
    } else {
        const win = window.open(url, 'Playbacks', 'width=1007,height=569');
        if(win){
            win.focus();
            externalWindowRef.current = win;
        }
        return <></>;
    }
};